export default __webpack_public_path__ + "static/media/location-unavailable.12b28620.png";